import CTABoilerplate from "./cta-boilerplate";
import Boilerplate from "./boilerplate";
import Colophon from "./colophon";
import Navigation from "./navigation";

import { useContext } from "react";
import { DataContext } from "~/context/content";
import get from "lodash.get";

export default function GlobalFooter() {

    const pageData = useContext(DataContext);
    const type = get(pageData, "type");
    const slug = get(pageData, "slug");

    return (
        <footer>
                <CTABoilerplate pageType={type} />
                <Boilerplate />
                {type !== "embeddedpage" && type !== "landingpages" && slug !== "construction" && <Navigation />}
                {slug !== "construction" && type !== "embeddedpage" && <Colophon />}
        </footer>
    );
}
